import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { api } from './api'
import {
  BankAccountCreatePage,
  BankAccountCreatePagePayload,
  BankAccountDetailsPage,
  BankAccountDetailsPagePayload,
  BankAccountEditPage,
  BankAccountEditPagePayload
} from './types'

const DETAILS_WEBPAGE_KEY_ROOT = 'BANK_ACCOUNT_DETAILS'
const CREATE_WEBPAGE_KEY_ROOT = 'BANK_ACCOUNT_CREATE'
const EDIT_WEBPAGE_KEY_ROOT = 'BANK_ACCOUNT_EDIT'

const useDetailsPage = (payload: BankAccountDetailsPagePayload) =>
  useSuspenseQuery<BankAccountDetailsPage>({
    queryKey: [DETAILS_WEBPAGE_KEY_ROOT, payload],
    queryFn: () => api.getDetailsPage(payload)
  })

const useCreatePage = (payload: BankAccountCreatePagePayload) =>
  useQuery<BankAccountCreatePage>({
    queryKey: [CREATE_WEBPAGE_KEY_ROOT, payload],
    queryFn: () => api.getCreatePage(payload)
  })

const useEditPage = (payload: BankAccountEditPagePayload) =>
  useQuery<BankAccountEditPage>({
    queryKey: [EDIT_WEBPAGE_KEY_ROOT, payload],
    queryFn: () => api.getEditPage(payload)
  })

const useUpdate = ({ onSuccess, onError }: { onSuccess: () => void; onError: (error) => void }) =>
  useMutation({
    mutationFn: api.update,
    onSuccess,
    onError
  })

const useDelete = ({ onSuccess, onError }: { onSuccess: () => void; onError: (error) => void }) =>
  useMutation({
    mutationFn: api.delete,
    onSuccess,
    onError
  })

export const hooks = {
  useDetailsPage,
  useCreatePage,
  useEditPage,
  useUpdate,
  useDelete
}
